export const DMS_MODULE = 'Sestavy';
export const NAME = 'OutSourcingDetail';
export const EXPORT_FILE_NAME = 'OutSourcingDetail.xlsx';
export const CRUMB_LABEL_KEY = 'OutSourcingDetail';
export const SUPPLIER_MULTISELECT_LIMIT = 25;